/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/document';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrievePreliminaryCaliforniaFinanceDisclosureDocumentRequest": {
                "fields": {}
              },
              "RetrievePreliminaryCaliforniaFinanceDisclosureDocumentResponse": {
                "fields": {
                  "document": {
                    "type": ".squareup.corporate_card.resources.Document",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrievePreliminaryCaliforniaFinanceDisclosureDocumentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrievePreliminaryCaliforniaFinanceDisclosureDocumentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrievePreliminaryCaliforniaFinanceDisclosureDocumentRequest @ squareup/corporate_card/service/retrieve_preliminary_california_finance_disclosure_document.proto at 9:1
 */
export const RetrievePreliminaryCaliforniaFinanceDisclosureDocumentRequest = $root.lookupType('squareup.corporate_card.service.RetrievePreliminaryCaliforniaFinanceDisclosureDocumentRequest');
fixType(RetrievePreliminaryCaliforniaFinanceDisclosureDocumentRequest);
Builder.createAndAttachToType(RetrievePreliminaryCaliforniaFinanceDisclosureDocumentRequest);
/**
 * SOURCE RetrievePreliminaryCaliforniaFinanceDisclosureDocumentResponse @ squareup/corporate_card/service/retrieve_preliminary_california_finance_disclosure_document.proto at 15:1
 */
export const RetrievePreliminaryCaliforniaFinanceDisclosureDocumentResponse = $root.lookupType('squareup.corporate_card.service.RetrievePreliminaryCaliforniaFinanceDisclosureDocumentResponse');
fixType(RetrievePreliminaryCaliforniaFinanceDisclosureDocumentResponse);
Builder.createAndAttachToType(RetrievePreliminaryCaliforniaFinanceDisclosureDocumentResponse);